import type { HyroxEventName, HyroxEvents } from 'app/utils/analytics/types';
import { getRecordRelayClient } from 'app/utils/analytics/recordrelay/client';
import { isMobileDevice } from 'app/utils/is-mobile';

let runtimeProperties: Record<string, unknown> = {
  platform: 'web',
};

export const setGlobalAnalyticsProperties = (props: Record<string, unknown>): void => {
  runtimeProperties = { ...runtimeProperties, ...props };
};

export const trackEvent = <T extends HyroxEventName>(name: T, props: HyroxEvents[T]): void => {
  getRecordRelayClient()
    ?.emit(name, {
      ...runtimeProperties,
      device_type: isMobileDevice() ? 'mobile' : 'desktop',
      ...(props as Record<string, unknown>),
    })
    .catch(() => undefined);
};
